import React from 'react';
import { useTranslation } from 'react-i18next';
import PaymentMethodSettings from './PaymentMethodSettings';
import { API_BASE_URL } from '@/config';
import axios from 'axios';

export default function GlobalSettings() {
  const { t } = useTranslation();
  const onSave = async (formValues) => {
    try {
      await axios.put(API_BASE_URL + '/settings/global/update', formValues);
    } catch (error) {
      console.error('Error updating settings:', error);
    }
  };

  const getGLobalPaymentSettings = async () => {
    const res = await axios.get(API_BASE_URL + '/settings/global');
    return res.data;
  };

  return (
    <div style={{ minWidth: '100%' }}>
      <h3 style={{ minWidth: '100%' }}>{t('settings.global.title')}</h3>
      <PaymentMethodSettings
        onSave={onSave}
        fetchFormValues={getGLobalPaymentSettings}
      />
    </div>
  );
}
